var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRitmoEcg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.92837 21.8053C9.51625 25.4045 20.1049 36 20.1049 36C20.1049 36 35.2767 20.8169 35.4494 20.626H35.4516C37.0649 18.8605 38.0624 16.4337 38.0624 13.7525C38.0624 8.36498 34.0428 4 29.0825 4C24.1222 4 20.1026 8.36498 20.1026 13.7525C20.1026 14.0206 20.1026 14.0206 20.1026 13.7525C20.1026 8.36498 16.083 4 11.1227 4C6.16243 4 2.14282 8.36498 2.14282 13.7525C2.14282 16.0997 2.9063 18.2515 4.17876 19.933",
    fill: "#F5FBFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92837 21.8053C9.51625 25.4045 20.1049 36 20.1049 36C20.1049 36 35.2767 20.8169 35.4494 20.626H35.4516C37.0649 18.8605 38.0624 16.4337 38.0624 13.7525C38.0624 8.36498 34.0428 4 29.0825 4C24.1222 4 20.1026 8.36498 20.1026 13.7525M20.1026 13.7525C20.1026 14.0206 20.1026 14.0206 20.1026 13.7525ZM20.1026 13.7525C20.1026 8.36498 16.083 4 11.1227 4C6.16242 4 2.14282 8.36498 2.14282 13.7525C2.14282 16.0997 2.9063 18.2515 4.17876 19.933",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 20.1807H6.67607L9.30506 13.7252L12.6112 25.2659C12.5475 25.116 13.636 19.7921 13.636 19.7921L20.8935 19.9966",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 20,
    r: 3.5,
    fill: "#F9839A",
    stroke: "#228C80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRitmoEcg);
export default __webpack_public_path__ + "static/media/Ic_ritmo ECG.2d4caad63ff9110810333319b1bdd58c.svg";
export { ForwardRef as ReactComponent };